import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Piece } from 'app/models/piece';
import { Observable, Subject, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PiecesService {

  base_path = 'https://app.titv-store-api.com/';

  constructor(private http: HttpClient) { }
  
  private refreshData = new Subject<void>();
  
  get refreshNedeed() {
    return this.refreshData;
  }

  // ✅ MÊME MÉTHODE QUE MAGAZINE SERVICE
  private getToken(): string {
    try {
      const authUser = sessionStorage.getItem('auth-user');
      if (authUser) {
        const userObj = JSON.parse(authUser);
        return userObj.token || '';
      }
      return '';
    } catch {
      return '';
    }
  }

  // ✅ MÊME MÉTHODE QUE MAGAZINE SERVICE
  private getHeaders(): HttpHeaders {
    const token = this.getToken();
    
    if (token) {
      return new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      });
    }
    
    return new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }

  // ✅ MÊME MÉTHODE QUE MAGAZINE SERVICE
  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Une erreur est survenue';
    
    if (error.status === 403) {
      errorMessage = `Accès interdit. Token: ${this.getToken() ? 'présent' : 'absent'}`;
    } else if (error.status === 401) {
      errorMessage = 'Non autorisé. Veuillez vous reconnecter.';
    } else {
      errorMessage = `Erreur ${error.status}: ${error.message}`;
    }
    
    console.error('Erreur PiecesService:', errorMessage);
    return throwError(() => new Error(errorMessage));
  }

  createPiece(item: any, idProjet: any): Observable<Piece> {
    const headers = this.getHeaders();
    
    return this.http.post<Piece>(
      this.base_path + 'projets/piece/add/' + idProjet, 
      JSON.stringify(item), 
      { headers }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }

  // Get single Piece data by ID
  getPiece(id: any): Observable<Piece> {
    const headers = this.getHeaders();
    
    return this.http.get<Piece>(
      this.base_path + 'projets/piece/' + id,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }

  // Get Pieces data
  getListPiece(): Observable<Piece[]> {
    const headers = this.getHeaders();
    
    return this.http.get<Piece[]>(
      this.base_path + 'projets/piece/all',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  // Update item by id
  updatePiece(id: any, item: any): Observable<Piece> {
    const headers = this.getHeaders();
    
    return this.http.put<Piece>(
      this.base_path + 'projets/piece/update/' + id, 
      JSON.stringify(item), 
      { headers }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }

  deletePiece(id: any): Observable<any> {
    const headers = this.getHeaders();
    
    return this.http.delete(
      this.base_path + 'projets/piece/delete/' + id,
      { 
        headers,
        responseType: 'text'
      }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }
}